module.exports = __webpack_public_path__ + "static/kart-bg-4e22163ead56a0a639ee0a6d16bee71f.jpg";